import { useBaseApiMutation } from "@mutation/baseMutation";


/*/api/v1/eventTimeRule/
C */

export const useCreateTimeRule = () => {
    return useBaseApiMutation({
        method: "POST",
        endpoint: "/eventTimeRule/"
    });
}


export const useDeleteTimeRule = () => {
    return useBaseApiMutation({
        method: "DELETE",
        endpoint: "/eventTimeRule/{clubEventTimeRule_uuid}"
    });
}